/**
 * Created by or_p on 2/25/2017.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import BaseDialog from 'shared/components/Dialogs/BaseDialog/BaseDialog';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import {templateService} from 'shared/helpers/TemplateService';
import _ from 'lodash';
import { EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import CircularProgress from 'material-ui/CircularProgress';
import { clearSaveError } from 'crazyEditor/redux/modules/editor/editor';
import { KEYS } from 'crazyEditor/core/constants/editorConstants';
import InlineNotification, {LEVEL_NOTICE} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';

export const TEMPLATE_NAME_DIALOG_TYPE = {
  SAVE: 0,
  RENAME: 1,
};

@connect(
  state => ({
    saving: state.editor.saving,
    saveError: state.editor.saveError,
    templateName: state.template.editable && state.template.name,
    openedLazyPanels: state.panel.openedLazyPanels,
    listingData: state.listingData,
  }), {closeLazyPanel, clearSaveError}
)
export default class TemplateNameDialog extends Component {
  static contextTypes = {
    integrationConnector: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  componentDidMount() {
    window.setTimeout(() => {
      const {open} = this.props;
      const {templateName} = this.refs;
      if (open) {
        templateName.focus();
      }
    }, 450);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      const {clearSaveError} = this.props;
      clearSaveError();
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  componentDidUpdate(prevProps) {
    const {open} = this.props;
    window.setTimeout(() => {
      const {templateName} = this.refs;
      if (!prevProps.open && open) {
        templateName.focus();
      }
    }, 450);

  }

  getStateFromProps(props) {
    const {templateName} = props;
    return {
      templateName: templateName || '',
    };
  }

  getErrorText() {
    const {saveError} = this.props;
    let message;
    switch (saveError) {
      case 1003:
        message = 'A Template with that name already exist';
        break;
      case 'error':
        message = 'Unknow error';
        break;
      default:
        message = undefined;
    }
    return message;
  }

  handleSave = () => {
    if (this.inputValid()) {
      const {templateName} = this.state;
      const {integrationConnector} = this.context;
      templateService.saveWithName(templateName, false, integrationConnector).catch(() => {});
    }
  };

  handleClose = () => {
    const {closeLazyPanel} = this.props;
    closeLazyPanel(EDITOR_PANELS.TEMPLATE_NAME);
  };

  handleChange = (e, templateName) => {
    const {saveError, clearSaveError} = this.props;
    if (saveError) {
      clearSaveError();
    }
    this.setState({templateName});
  };

  handleKeyDown = (event) => {
    if (event.keyCode === KEYS.ENTER) {
      this.handleSave();
    }
  };

  inputValid() {
    const {panelProps: {type}} = this.props;
    const currentTemplateName = this.props.templateName;
    const {templateName} = this.state;
    switch (type) {
      case TEMPLATE_NAME_DIALOG_TYPE.SAVE:
        return !_.isEmpty(templateName);
      case TEMPLATE_NAME_DIALOG_TYPE.RENAME:
        return currentTemplateName !== templateName;
      default:
        return false;
    }
  }

  buttonLabel() {
    const {panelProps: {type}, saving} = this.props;
    switch (type) {
      case TEMPLATE_NAME_DIALOG_TYPE.SAVE:
        return saving ? 'saving...' : 'save';
      case TEMPLATE_NAME_DIALOG_TYPE.RENAME:
        return saving ? 'renaming...' : 'rename';
      default:
        return false;
    }
  }

  title() {
    const {panelProps: {type}} = this.props;
    switch (type) {
      case TEMPLATE_NAME_DIALOG_TYPE.SAVE:
        return 'Name Your Template';
      case TEMPLATE_NAME_DIALOG_TYPE.RENAME:
        return 'Rename Your Template';
      default:
        return false;
    }
  }

  render() {
    const {saving, listingData, panelProps: {onClose, type}, ...other} = this.props;
    const {templateName} = this.state;
    const actions = [
      <FlatButton
        label="cancel"
        onClick={this.handleClose}
      />,
      <FlatButton
        disabled={!this.inputValid()}
        hoverColor={saving ? 'none' : undefined}
        style={{width: 145}}
        primary
        onClick={this.handleSave}
        icon={saving ? <CircularProgress thickness={2} size={24} style={{transform: 'translate3d(2px, 5px, 0px)', marginLeft: -12, height: 36, width: 36}}/> : undefined}
        label={this.buttonLabel()}
      />
    ];
    return (
      <BaseDialog
        {...other}
        actions={actions}
        title={this.title()}
        onRequestClose = {this.handleClose}
        onClose = {onClose}
      >
        {
          !_.isEmpty(listingData) &&
            <InlineNotification
              level={LEVEL_NOTICE}
              animate={false}
            >
              Saving this design as a template will <strong>not</strong> update your listing on eBay<br/> Click "Save & Revise" to update your listing on eBay.
            </InlineNotification>
        }
        <TextField
          ref="templateName"
          value={templateName}
          style={{width: '100%'}}
          floatingLabelText="Template's Name"
          hintText="Enter a meaningful name like: Pink vacuum cleaners"
          onChange={this.handleChange}
          errorText={this.getErrorText()}
          errorStyle = {{float: 'left'}}
          onKeyDown = {this.handleKeyDown}
        />
      </BaseDialog>
    );
  }
}